import { Injectable } from '@angular/core';

@Injectable()
export class PortalService {

  constructor() { }

  public isPortalPath(path: string) {
    return path.startsWith('/portal/');
  }

}



// WEBPACK FOOTER //
// ./src/app/portal/portal.service.ts